<template>
  <div>
    <div v-if="is_admin">
      <router-view/>
    </div>
    <div v-else class="main">
      <header>
        <div class="header-main">
          <div class="left">
            <img src="./assets/logo.png">
          </div>
          <div class="center">
            <top-menu v-if="username" :roles="roles" />
          </div>
          <a href="javascript:;" v-if="username" @click="logout" class="right">
            <i></i>
            <span>{{ username }}</span>
          </a>
        </div>
      </header>
      <div class="page-body" id="app">
        <router-view @loginSucess="getUsername" />
      </div>
      <footer>蜀ICP备14015377号-14</footer>
    </div>
  </div>
</template>
<script>
import Cookie from '@/common/cookie'
import Service from '@/service'
import TopMenu from '@/components/menu'
export default {
  name: 'App',
  data() {
    return {
      is_admin: this.$route.path.indexOf('/admin/') === 0,
      roles: Cookie.getItem('roles') ? Cookie.getItem('roles').split(',') : [],
      username: Cookie.getItem('cdfang_name') || '',
    }
  },
  mounted() {
    if (Cookie.getItem('cdfang_token')) {
      Service.getUserInfo().then(({ data }) => {
        this.$store.dispatch('setRoles', data.roles)
      })
    }
  },
  methods: {
    getUsername() {
      this.username = Cookie.getItem('cdfang_name') || ''
      this.roles = Cookie.getItem('roles').split(',') || []
    },
    logout() {
      Cookie.clearItems()
      this.$store.dispatch('setRoles', [])
      this.$store.dispatch('setHouses', [])
      this.username = ''
      this.$router.push('/login')
    },
  },
  components: {
    TopMenu,
  },
}
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
header {
  width: 100%;
  background-image: linear-gradient(-90deg, #00c6d6 3%, #00ad82 100%);
  color: #fff;
  .header-main {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    padding: 0 24px;
  }
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 64px;
    img {
      width: 700 / 204 * 34 * 1px;
      height: 34px;
    }
  }
  h1 {
    display: inline-block;
    margin: 0;
    margin-right: 80px;
    font-size: 20px;
    font-weight: normal;
  }
  .center {
    flex: 1;
  }
  .right {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    color: #fff;
    text-decoration: none;
    i {
      width: 20px;
      height: 23px;
      background-image: url(./assets/img/logout.png);
      background-size: 100% 100%;
      margin-right: 12px;
    }
  }
}
.page-body {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}
footer {
  width: 100%;
  text-align: center;
  flex: 0 0 48px;
  line-height: 48px;
  background-color: #fff;
  font-size: 14px;
  color: #999;
}
</style>
